// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './SwitchesPanel';



// WEBPACK FOOTER //
// ./components/SwitchesPanel/index.js